import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Main from "../../components/layout/Main";
import { useToggleTop } from "../../components/common/ToggleTop";
import { Settings } from "../../storage/store";
import "../../assets/styles/app-preferences.css";

// The app's Home Voltage screen (app/screens/HomeSettings/HomeVoltage.js): the
// mains voltage of the home, kept in this browser. "Update" works once the
// value has changed.
function HomeVoltage() {
  const history = useHistory();
  const toast = useToggleTop();
  const saved = Settings.getHomeVoltage();
  const [voltage, setVoltage] = useState(saved);
  const changed = voltage !== saved;

  const update = (event) => {
    event?.preventDefault();
    if (!changed) return;
    if (!voltage.trim().length) {
      toast("Voltage is required!", "red");
      return;
    }
    if (Number.isNaN(Number(voltage))) {
      toast("Only numbers are allowed!", "red");
      return;
    }
    Settings.setHomeVoltage(voltage.trim());
    toast("Voltage Updated!", "green");
    history.goBack();
  };

  return (
    <Main
      header="stack"
      title="Home Voltage"
      hideTabBar
      headerRight={
        <button type="submit" form="hx-pref-voltage" className="hx-edit-update" disabled={!changed}>
          Update
        </button>
      }
    >
      <form id="hx-pref-voltage" className="hx-pref-form" onSubmit={update} noValidate>
        <label className="hx-field">
          <span className="hx-field-label">Voltage</span>
          <input
            className="hx-field-input"
            inputMode="numeric"
            maxLength={4}
            autoComplete="off"
            value={voltage}
            onChange={(event) => setVoltage(event.target.value)}
          />
        </label>
      </form>
    </Main>
  );
}

export default HomeVoltage;
